import ConnectionsFlow from "../ConnectionsFlow";

export default function AddContactsScreen() {
  return <ConnectionsFlow />;
}
